module.exports = __webpack_public_path__ + "img/title-dver-1-m@2x.7e78a29f.png";